import { ThemedButton, Stack, Link } from '.'

export const EmailButtons = () => {
  return (
    <Stack direction="row" spacing="2rem" sx={{ justifyContent: 'center' }}>
      <Link href="https://mail.google.com" target="_blank">
        <ThemedButton variant="outlined" size="small">
          Open Gmail
        </ThemedButton>
      </Link>
      <Link href="https://www.icloud.com/mail" target="_blank">
        <ThemedButton variant="outlined" size="small">
          Open Apple Mail
        </ThemedButton>
      </Link>
      <Link href="https://outlook.live.com/owa/" target="_blank">
        <ThemedButton variant="outlined" size="small">
          Open Outlook
        </ThemedButton>
      </Link>
    </Stack>
  )
}
